/**
 * TS1 Portal mobile app — Bluetooth setup for base units (Wi-Fi, Ethernet, customer ID).
 * Add Google Play and App Store URLs when available; empty strings hide those buttons.
 */
export const TS1_PORTAL = {
  displayName: 'TS1 Portal',
  /** Google Play store URL (empty until published) */
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=com.thermalsystems.ts1portal',
  /** Apple App Store URL (empty until published) */
  iosStoreUrl: '',
} as const;
